function initHeros(){
	
	$("body").addClass('hero-'+$('.hero-carousel .item').data('theme'));	
	var carousel = $(".hero-carousel");			
		carousel.slick({
			infinite: true,
			focusOnSelect: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			speed: 500,
			swipeToSlide:true,
			fade: true,  
			arrows:false,
			cssEase: 'linear',				
		});
	
	$('.heros .scroll-btn').click(function(e){
		$("html, body").animate({ scrollTop: $('.heros').innerHeight() }, 500);	
		e.preventDefault();
	});
	
	$('.heros .hero-controls ul li').click(function(e){
		carousel.slick("goTo", $(this).data('index'));	
		e.preventDefault();
	});
	
	carousel.on('afterChange', function(){
		$("body").removeClass('hero-dark').removeClass('hero-white');
		$("body").addClass('hero-'+$('.heros .slick-current .item').data('theme'));		
		$('.heros .hero-controls ul li.active').removeClass('active');	
		var index = $('.heros .slick-current').data('slick-index');
		$('.heros .hero-controls ul li[data-index="'+index+'"]').addClass('active');	  	
	});	
}
$(function(){
	"use strict";
	$('.category-hero .scroll-btn').click(function(e){
		$("html, body").animate({ scrollTop: $('.category-hero').innerHeight() }, 500);	
		e.preventDefault();
	});
});
		